import { defineSlotRecipe } from '@chakra-ui/react';

/*
 * v3 port notes:
 * - v2's single `Avatar` part becomes a 3-slot component in v3 (`root`/
 *   `image`/`fallback`, from `@ark-ui/react/avatar`'s `avatarAnatomy`,
 *   confirmed via the built-in `avatar` recipe in
 *   `@chakra-ui/react/dist/esm/theme/recipes/avatar.js`). There is no
 *   `badge` slot in v3 at all (`AvatarBadge` has zero export) — compose an
 *   absolutely-positioned box instead, since `Avatar.Root` is already
 *   `position: relative` in the built-in recipe.
 * - The built-in `avatar` recipe's default `variant` is `subtle`, which sets
 *   its own `root.color` (and `_hover` etc.). Left unset here: foreground is
 *   supplied per-avatar by `MAvatar` alongside its background (see
 *   `getAvatarColorsFromName`), so the two always stay in step if the
 *   palette changes — inline `bg`/`color` props always win over
 *   recipe-derived styles.
 * - Only `md` is customized (52px, matching the app's original size), same
 *   as v2's own file. The default is `2xs` (`sizes.6`, 24px), not `xs`: v3's
 *   built-in scale runs a step larger than v2's, so v3 `2xs` is v2 `xs`.
 * - `3xs` restores v2's `2xs` (16px), which the built-in scale has no step
 *   for. v2 sized its initials at avatar / 2.5, hence 0.4rem.
 */

const avatarTheme = defineSlotRecipe({
  slots: ['root', 'image', 'fallback'],
  base: {},
  variants: {
    size: {
      '3xs': {
        root: {
          '--avatar-size': 'sizes.4',
          '--avatar-font-size': '0.4rem',
        },
      },
      // Declared (but empty) so `defaultVariants` below can reference it —
      // the built-in's own `2xs` (`fontSizes.2xs` / `sizes.6`) is used as-is.
      '2xs': {},
      md: {
        root: {
          '--avatar-size': '52px',
        },
        fallback: {
          fontSize: '18px',
          fontWeight: 'semibold',
        },
      },
    },
  },
  defaultVariants: {
    size: '2xs',
  },
});

export default avatarTheme;
